import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

const config = process.env.FIREBASE

function initFirebase () {
  return new Promise(resolve => {
    firebase.initializeApp(config)
  })
}

initFirebase()

firebase.firestore() // eslint-disable-line no-unused-vars

// db.enablePersistence()
//   .catch(function (err) {
//     if (err.code === 'failed-precondition') {
//       // Multiple tabs open, persistence can only be enabled
//       // in one tab at a a time.
//       // ...
//     } else if (err.code === 'unimplemented') {
//       // The current browser does not support all of the
//       // features required to enable persistence
//       // ...
//     }
//   })

export default firebase
